import angular from "angular";
import { configureStates, lazyLoad, resolveFromParam } from "../../core/router/router-helper.provider";

const routes = [{
    state: "leads",
    config: {
        url: "/leads",
        abstract: true
    }
}, {
    // Redirect from MVC route to semantic route.
    state: "leads.importLeads",
    config: {
        url: "/importleads",
        redirectTo: "leads.importer"
    }
}, {
    state: "leads.importer",
    config: {
        // Lazy load the importer module containing the component so that
        // the fairly large dependency on ExcelParserModule is omitted from the main build.
        url: "/importer",
        component: "apexLeadsImporter",
        data: {
            pageHeader: "Import Leads",
            permissionKey: "navigation:importLeads"
        },
        lazyLoad: lazyLoad(() => import("./importer/leads-importer.module").then(mod => mod.LeadsImporterModule))
    }
}, {
    state: "leads.leadsConversionReport",
    config: {
        url: "/leadsconversionreport",
        component: "apexLeadsConversionReport",
        data: {
            pageHeader: "Leads Conversion Report"
        }
    }
}, {
    state: "leads.leadsConversionDetailReport",
    config: {
        url: "/leadsconversiondetailreport?mapAreaCode",
        component: "apexLeadsConversionDetailReport",
        data: {
            pageHeader: "Leads Conversion Detail Report"
        },
        resolve: {
            mapAreaCode: resolveFromParam("mapAreaCode")
        }
    }
}];

export const LeadsRoutingModule = angular
    .module("apex.mainApp.leads.routing", [])
    .run(configureStates(routes))
    .name;
